module.exports = __webpack_public_path__ + "img/our_values_lg.2a7d426c.svg";